


import React, { createContext, useState, useContext } from "react";

const EnergiaIluminacaoContext = createContext();

export default function AmbienteProvider({ children }) {
  const [energiaIluminacao_id, setEnergiaIluminacao_id] = useState();

  return (
    <EnergiaIluminacaoContext.Provider value={{ energiaIluminacao_id, setEnergiaIluminacao_id }} >
      {children}
    </EnergiaIluminacaoContext.Provider>
  );
}

export function useEnergiaIluminacaoContext() {
  const context = useContext(EnergiaIluminacaoContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { energiaIluminacao_id, setEnergiaIluminacao_id } = context;
  return { energiaIluminacao_id, setEnergiaIluminacao_id };
}

